import { render, staticRenderFns } from "./FinancialSupport.vue?vue&type=template&id=230f5878"
import script from "./FinancialSupport.vue?vue&type=script&lang=js"
export * from "./FinancialSupport.vue?vue&type=script&lang=js"
import style0 from "./FinancialSupport.vue?vue&type=style&index=0&id=230f5878&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports